import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  GetChargebeeIntegrationUrlResponseDto,
  GetPaymentInformationResponseDto,
  UpdatePaymentInformationBillingAddressRequestDto,
} from '../interfaces/settings/payment-information.interface';

@Injectable({
  providedIn: 'root',
})
export class PaymentAdapter {
  private http = inject(HttpClient);

  getPaymentInformation(): Observable<GetPaymentInformationResponseDto> {
    return this.http.get<GetPaymentInformationResponseDto>(`${environment.apiBaseUrl}/company/billing`);
  }

  updateBillingAddress(payload: UpdatePaymentInformationBillingAddressRequestDto): Observable<any> {
    return this.http.patch(`${environment.apiBaseUrl}/company/billing`, payload);
  }

  setBankTransfer(): Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/company/set-bank-transfer`, {});
  }

  getChargebeeIntegrationUrl(): Observable<GetChargebeeIntegrationUrlResponseDto> {
    return this.http.get<GetChargebeeIntegrationUrlResponseDto>(
      `${environment.apiBaseUrl}/company/edit-payment-method-url`
    );
  }

  getSepaAgreementUrl(): Observable<GetChargebeeIntegrationUrlResponseDto> {
    return this.http.get<GetChargebeeIntegrationUrlResponseDto>(
      `${environment.apiBaseUrl}/company/download-agreement-url`
    );
  }
}
